import EntityNotificationAdd from './EntityNotificationAdd';

export default EntityNotificationAdd;
